import React from "react";

import { usePermanent } from "~/tools/use-permanent";

import { TimestampCursorContextProvider } from "./_context";
import { TimestampCursorState } from "./TimestampCursorState";
import { SET_TIMESTAMP_MARKER_HOTKEY } from "./use-timestamp-cursor";

export const TimestampCursorProvider: React.FC<
	React.PropsWithChildren<{
		initialState?: TimestampCursorState;
	}>
> = ({ initialState, children }) => {
	const state = usePermanent(() => initialState ?? new TimestampCursorState());

	React.useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			state.setHotkeyPressed(event.key === SET_TIMESTAMP_MARKER_HOTKEY);
		};

		const onKeyUp = () => {
			state.setHotkeyPressed(false);
		};

		document.addEventListener("keydown", onKeyDown);
		document.addEventListener("keyup", onKeyUp);

		return () => {
			document.removeEventListener("keydown", onKeyDown);
			document.removeEventListener("keyup", onKeyUp);
		};
	}, [state]);

	return <TimestampCursorContextProvider value={state}>{children}</TimestampCursorContextProvider>;
};
